/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import { combineReducers } from "redux";
import commonReducer from './commonReducer';
import authReducer from './authReducer';
import deliveryOrderReducer from './deliveryOrderReducer';
import accountReducer from './accountReducer';
import deliverySheetReducer from './deliverySheetReducer';
import appReducer from './appReducer';
import merchantReducer from "./merchantReducer";
import kpiReducer from "./kpiReducer";
import operationReducer from "./operationReducer";
import socketReducer from "./socketReducer";
import helpDeskReducer from "./helpDeskReducer";
import notificationReducer from "./notificationReducer";

export const reducers = combineReducers({
  auth: authReducer,
  common: commonReducer,
  deliveryOrder: deliveryOrderReducer,
  account: accountReducer,
  deliverySheet:deliverySheetReducer,
  app:appReducer,
  merchant:merchantReducer,
  kpi:kpiReducer,
  operation:operationReducer,
  socket: socketReducer,
  helpDesk: helpDeskReducer,
  notification: notificationReducer
});
